/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetFwLeaderboardsVictoryPoints } from './GetFwLeaderboardsVictoryPoints';
import {
    GetFwLeaderboardsVictoryPointsFromJSON,
    GetFwLeaderboardsVictoryPointsFromJSONTyped,
    GetFwLeaderboardsVictoryPointsToJSON,
    GetFwLeaderboardsVictoryPointsToJSONTyped,
} from './GetFwLeaderboardsVictoryPoints';
import type { GetFwLeaderboardsKills } from './GetFwLeaderboardsKills';
import {
    GetFwLeaderboardsKillsFromJSON,
    GetFwLeaderboardsKillsFromJSONTyped,
    GetFwLeaderboardsKillsToJSON,
    GetFwLeaderboardsKillsToJSONTyped,
} from './GetFwLeaderboardsKills';

/**
 * 200 ok object
 * @export
 * @interface GetFwLeaderboardsOk
 */
export interface GetFwLeaderboardsOk {
    /**
     * 
     * @type {GetFwLeaderboardsKills}
     * @memberof GetFwLeaderboardsOk
     */
    kills: GetFwLeaderboardsKills;
    /**
     * 
     * @type {GetFwLeaderboardsVictoryPoints}
     * @memberof GetFwLeaderboardsOk
     */
    victoryPoints: GetFwLeaderboardsVictoryPoints;
}

/**
 * Check if a given object implements the GetFwLeaderboardsOk interface.
 */
export function instanceOfGetFwLeaderboardsOk(value: object): value is GetFwLeaderboardsOk {
    if (!('kills' in value) || value['kills'] === undefined) return false;
    if (!('victoryPoints' in value) || value['victoryPoints'] === undefined) return false;
    return true;
}

export function GetFwLeaderboardsOkFromJSON(json: any): GetFwLeaderboardsOk {
    return GetFwLeaderboardsOkFromJSONTyped(json, false);
}

export function GetFwLeaderboardsOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsOk {
    if (json == null) {
        return json;
    }
    return {
        
        'kills': GetFwLeaderboardsKillsFromJSON(json['kills']),
        'victoryPoints': GetFwLeaderboardsVictoryPointsFromJSON(json['victory_points']),
    };
}

export function GetFwLeaderboardsOkToJSON(json: any): GetFwLeaderboardsOk {
    return GetFwLeaderboardsOkToJSONTyped(json, false);
}

export function GetFwLeaderboardsOkToJSONTyped(value?: GetFwLeaderboardsOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kills': GetFwLeaderboardsKillsToJSON(value['kills']),
        'victory_points': GetFwLeaderboardsVictoryPointsToJSON(value['victoryPoints']),
    };
}

